var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-footer"},[_c('span',{staticClass:"footer-text",staticStyle:{"margin-right":"5px"}},[_vm._v("ZNA GmbH")])])}]

export { render, staticRenderFns }